module.exports = __webpack_public_path__ + "static/media/blocked_lesson.919ae511.svg";